import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const CollaborativePhilosophySection = () => {
  const { t } = useLanguage();

  const principles = [
    {
      icon: "GitBranch",
      title: t('collaborativePhilosophy.principle1Title'),
      description: t('collaborativePhilosophy.principle1Desc')
    },
    {
      icon: "Award",
      title: t('collaborativePhilosophy.principle2Title'),
      description: t('collaborativePhilosophy.principle2Desc')
    },
    {
      icon: "Users",
      title: t('collaborativePhilosophy.principle3Title'),
      description: t('collaborativePhilosophy.principle3Desc')
    },
    {
      icon: "Heart",
      title: t('collaborativePhilosophy.principle4Title'),
      description: t('collaborativePhilosophy.principle4Desc')
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-xl border border-white/20 shadow-lg rounded-full mb-4 md:mb-6">
            <Icon name="Handshake" size={20} color="#0025cc" />
            <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('collaborativePhilosophy.badge')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('collaborativePhilosophy.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-3xl mx-auto mb-6">
            {t('collaborativePhilosophy.subtitle')}
          </p>
          <p className="text-base md:text-lg text-[#111827] max-w-3xl mx-auto leading-relaxed">
            {t('collaborativePhilosophy.description')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {principles?.map((principle, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center shadow-md">
                    <Icon name={principle?.icon} size={24} color="#FFFFFF" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-2">
                    {principle?.title}
                  </h3>
                  <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">
                    {principle?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CollaborativePhilosophySection;